import axios, { AxiosError } from 'axios';

export function CheckUnPublishError(error: AxiosError): boolean {
  // axios 1.x types response.data as `unknown`; narrow to the fields we read.
  const data = error?.response?.data as
    | { statusCode?: number; code?: number }
    | undefined;
  return (
    axios.isAxiosError(error) && data?.statusCode === 404 && data?.code === 16
  );
}
